// src/App.js
import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './LandingPage';
import CookiePolicy from './pages/CookiePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Coverage from './pages/Coverage';
import News from './pages/News';
import Security from './pages/Security';
import NotFound from './pages/NotFound';
import CookieConsent from './components/CookieConsent';
import features from './config/features';
import theme from './theme';
import './index.css';
import { initGA, logPageView } from './utils/googleAnalytics';
import { storeUTMParams } from './utils/utmTracking';
import { useLanguageFromURL } from './hooks/useLanguageFromURL';

// Initialize GA4
initGA();

// Store UTM parameters immediately on page load (before React routing)
if (window.location.search || window.location.hash.includes('?')) {
  storeUTMParams();
}

function GATracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function LanguageHandler({ children }) {
  useLanguageFromURL();
  return children;
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <LanguageHandler>
            <GATracker />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              {features.navigation.coverage && <Route path="/coverage" element={<Coverage />} />}
              {features.navigation.security && <Route path="/security" element={<Security />} />}
              {features.navigation.news && <Route path="/news" element={<News />} />}
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <CookieConsent />
          </LanguageHandler>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
